import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";
import { HEALTH_ENUM } from "shared/constant";

const parentBreadCrumbs = [
  { title: "menu_sidebar_health" },
  { title: "menu_sidebar_health_plan_setup" },
  { title: "menu_sidebar_health_plan_setup_b2b" },
  { title: "menu_sidebar_health_plan_setup_plans", link: "/health/plan-setup/b2b/plans" }
];

const ShelfPlanListing = Loadable({
  loader: () => import("container/bac/b2b/plans/listing"),
  loading() {
    return <Loader />;
  }
});
const ShelfPlanAdd = Loadable({
  loader: () => import("container/bac/b2b/plans"),
  loading() {
    return <Loader />;
  }
});

export const healthPlanB2BRoutes: IRoute[] = [
  {
    path: "/health/plan-setup/b2b/plans",
    element: <ShelfPlanListing lineOfBusiness={HEALTH_ENUM.HEALTH} />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/health/plan-setup/b2b/plans/details/:id?",
    element: <ShelfPlanAdd lineOfBusiness={HEALTH_ENUM.HEALTH} />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
